/* =========================================================
   OVERTOP — Checkout Enhance v11.0.0
   ---------------------------------------------------------
   v11 fixes the real first-attempt iOS failure:

   1) Horizon mobile cart drawer uses a history sentinel when
      opened and calls history.back() when it closes. If the
      checkout tap first closes the drawer, that back() races
      /checkout navigation and can cancel the first attempt.
      v11 neutralises that sentinel before navigation.

   2) After first add-to-cart, Horizon renders the cart
      asynchronously. v11 blocks drawer morph events during
      checkout intent so navigation isn't cancelled mid-render.

   3) If Horizon ever renders stale empty drawer HTML while
      /cart.js still contains items, v11 repairs the drawer
      section instead of letting the fake empty state persist.

   The checkout source should still be a real <a href="/checkout">.
   ========================================================= */
(function () {
  'use strict';

  var VERSION = '11.0.0';
  var STYLE_ID = 'ot-checkout-enhance-style-v11';
  var LEGACY_STYLE_IDS = [
    'ot-checkout-enhance-style',
    'ot-checkout-enhance-style-v9',
    'ot-checkout-enhance-style-v10'
  ];
  var PILL_CLASS = 'ot-free-delivery-pill';
  var ANCHOR_MARKER = 'data-ot-checkout-anchor';
  var BOUND_ATTR = 'data-ot-checkout-bound-v11';
  var INTENT_ATTR = 'data-ot-checkout-intent';

  var refreshQueued = false;
  var navigating = false;
  var intentTimer = null;
  var repairTimer = null;

  window.__OT_CHECKOUT_ENHANCE_VERSION = VERSION;
  window.__OT_CHECKOUT_IN_PROGRESS = false;

  function log() {
    if (!window.console) return;
    var args = ['[OT/checkout/v' + VERSION + ']'];
    for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
    try { console.log.apply(console, args); } catch (err) {}
  }

  function rootUrl() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return String(window.Shopify.routes.root || '/');
      }
    } catch (err) {}
    return '/';
  }

  function checkoutUrl() {
    return rootUrl().replace(/\/$/, '') + '/checkout';
  }

  function cartUrl(path) {
    return rootUrl().replace(/\/$/, '') + path;
  }

  function stopHard(e) {
    if (!e) return;
    if (e.cancelable && typeof e.preventDefault === 'function') e.preventDefault();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    else if (typeof e.stopPropagation === 'function') e.stopPropagation();
  }

  function setCheckoutIntent(source) {
    window.__OT_CHECKOUT_IN_PROGRESS = true;
    document.documentElement.setAttribute(INTENT_ATTR, '1');
    if (intentTimer) clearTimeout(intentTimer);
    intentTimer = setTimeout(clearCheckoutIntent, 8000);
    neutralizeDrawerHistory();
    installDrawerCloseGuard();
    try {
      document.dispatchEvent(new CustomEvent('ot:checkout-intent', {
        bubbles: true,
        detail: { source: source || 'unknown' }
      }));
    } catch (err) {}
    log('checkout intent:', source || 'unknown');
  }

  function clearCheckoutIntent() {
    navigating = false;
    window.__OT_CHECKOUT_IN_PROGRESS = false;
    document.documentElement.removeAttribute(INTENT_ATTR);
    if (intentTimer) {
      clearTimeout(intentTimer);
      intentTimer = null;
    }
  }

  function neutralizeDrawerHistory() {
    try {
      if (window.history && history.state && history.state.cartDrawerOpen) {
        history.replaceState(null, '', window.location.href);
        log('neutralized cartDrawerOpen history state');
      }
    } catch (err) {}
  }

  function installDrawerCloseGuard() {
    document.querySelectorAll('cart-drawer-component').forEach(function (drawer) {
      if (drawer.getAttribute('data-ot-close-guard-v11') === '1') return;
      drawer.setAttribute('data-ot-close-guard-v11', '1');
      drawer.addEventListener('dialog:close', function (e) {
        if (!window.__OT_CHECKOUT_IN_PROGRESS) return;
        neutralizeDrawerHistory();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        else if (typeof e.stopPropagation === 'function') e.stopPropagation();
        log('blocked drawer history close during checkout');
      }, true);
    });
  }

  function hardNavigate(url) {
    if (navigating) return;
    navigating = true;
    setCheckoutIntent('hard-navigate');
    log('navigate →', url);

    try {
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
    } catch (err) {}

    try { window.location.assign(url); }
    catch (err) { try { window.location.href = url; } catch (e) {} }

    setTimeout(function () {
      if (document.visibilityState !== 'hidden') {
        log('backup navigate →', url);
        try { window.location.href = url; } catch (err) {}
      }
    }, 450);

    setTimeout(function () {
      if (document.visibilityState !== 'hidden') {
        log('last-resort replace →', url);
        try { window.location.replace(url); }
        catch (err) { try { document.location = url; } catch (e) {} }
      }
    }, 1500);
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve) {
      var done = false;
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        resolve('timeout');
      }, ms || 1700);

      Promise.resolve(promise).then(function (value) {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve(value);
      }).catch(function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        resolve('error');
      });
    });
  }

  async function settleBeforeCheckout() {
    // Bundle engine removed — nothing to settle before checkout.
  }

  async function checkoutNow(e, target) {
    var url = (target && target.getAttribute && target.getAttribute('href')) || checkoutUrl();
    stopHard(e);
    setCheckoutIntent('checkout-click');
    await settleBeforeCheckout();
    neutralizeDrawerHistory();
    hardNavigate(url);
  }

  function injectStyles() {
    if (!document.querySelector('link[data-ot-anton]')) {
      var fl = document.createElement('link');
      fl.rel = 'stylesheet';
      fl.href = 'https://fonts.googleapis.com/css2?family=Anton&display=swap';
      fl.setAttribute('data-ot-anton', '1');
      (document.head || document.documentElement).appendChild(fl);
    }

    LEGACY_STYLE_IDS.forEach(function (id) {
      var old = document.getElementById(id);
      if (old && old.parentNode) old.parentNode.removeChild(old);
    });
    if (document.getElementById(STYLE_ID)) return;

    var css = [
      'cart-drawer-component button#checkout[form="cart-form"],',
      'dialog button#checkout[form="cart-form"],',
      '#cart-drawer button#checkout[form="cart-form"],',
      'main[data-template*="cart"] button#checkout[form="cart-form"]{',
      'display:none!important;visibility:hidden!important;pointer-events:none!important;',
      '}',
      'a#checkout[' + ANCHOR_MARKER + '].cart__checkout-button{',
      'width:100%;text-decoration:none!important;cursor:pointer;',
      'user-select:none;-webkit-user-select:none;-webkit-touch-callout:none;',
      '-webkit-tap-highlight-color:transparent;touch-action:manipulation;',
      'display:flex;align-items:center;justify-content:center;',
      'pointer-events:auto!important;',
      '}',
      'a#checkout[' + ANCHOR_MARKER + '] .button-text{white-space:nowrap;}',
      'a#checkout[' + ANCHOR_MARKER + '][aria-disabled="true"]:not([href]){opacity:.7;cursor:default;}',
      'html[' + INTENT_ATTR + '="1"] cart-drawer-component button#checkout[form="cart-form"]{display:none!important;}',
      '.' + PILL_CLASS + '{display:flex;align-items:center;justify-content:center;gap:6px;margin-top:8px;padding:6px 10px;font-size:12.5px;font-weight:600;line-height:1.2;color:#0e8a3e;background:#e8f7ee;border-radius:6px;}',
      '.' + PILL_CLASS + ' .ot-strike{text-decoration:line-through;color:#888;font-weight:500;}',
      '.' + PILL_CLASS + ' .ot-free{letter-spacing:.02em;}'
    ].join('');

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    (document.head || document.documentElement).appendChild(style);
  }

  function getCartTotalText(root) {
    root = root || document;
    var el =
      root.querySelector('[data-testid="cart-total-value"]') ||
      root.querySelector('[data-cart-subtotal]') ||
      root.querySelector('.cart-totals__total-value');
    if (!el) return null;
    var txt = (el.getAttribute('value') || el.textContent || '').trim();
    if (!txt) return null;
    // Drop a trailing ".00" (zero paisa) — keeps real paisa like ".50".
    return txt.replace(/\s+/g, ' ').trim().replace(/\.00(?!\d)/g, '');
  }

  function getButtonLabel(root) {
    var total = getCartTotalText(root);
    return total ? 'CHECKOUT — ' + total : 'CHECKOUT';
  }

  function isCheckoutContext(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('cart-drawer-component, dialog, #cart-drawer, main[data-template*="cart"]');
  }

  function findCheckoutTarget(target) {
    if (!target || !target.closest) return null;
    var el = target.closest(
      'a#checkout[' + ANCHOR_MARKER + '], ' +
      'a#checkout.cart__checkout-button[href], ' +
      'a.cart__checkout-button[href*="checkout"], ' +
      'button#checkout, ' +
      'button[name="checkout"][form="cart-form"]'
    );
    if (!el || !isCheckoutContext(el)) return null;
    return el;
  }

  function isCheckoutAnchor(el) {
    return !!(el && el.tagName === 'A' && el.getAttribute('href'));
  }

  function makeAnchorFromButton(btn, rootForLabel) {
    var doc = btn.ownerDocument || document;
    var anchor = doc.createElement('a');
    anchor.id = 'checkout';
    anchor.className = btn.className || 'cart__checkout-button button';
    anchor.setAttribute(ANCHOR_MARKER, '1');
    anchor.setAttribute('data-ot-native-checkout-link', '1');

    if (btn.disabled || btn.hasAttribute('disabled')) {
      anchor.setAttribute('aria-disabled', 'true');
      anchor.setAttribute('tabindex', '-1');
    } else {
      anchor.setAttribute('href', checkoutUrl());
    }

    for (var i = 0; i < btn.attributes.length; i++) {
      var a = btn.attributes[i];
      if (a.name.indexOf('data-') === 0 && a.name !== ANCHOR_MARKER) {
        anchor.setAttribute(a.name, a.value);
      }
    }

    var span = doc.createElement('span');
    span.className = 'button-text';
    span.textContent = getButtonLabel(rootForLabel || doc);
    anchor.appendChild(span);
    return anchor;
  }

  function rewriteCheckoutButtons(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(
      'cart-drawer-component button#checkout[form="cart-form"], ' +
      'dialog button#checkout[form="cart-form"], ' +
      'main[data-template*="cart"] button#checkout[form="cart-form"], ' +
      '#cart-drawer button#checkout[form="cart-form"]'
    ).forEach(function (btn) {
      if (!btn.parentNode) return;
      btn.parentNode.replaceChild(makeAnchorFromButton(btn, root), btn);
    });
  }

  function patchDOMParser() {
    if (!window.DOMParser || window.DOMParser.__otCheckoutPatchedV11) return;
    var nativeParse = window.DOMParser.prototype.parseFromString;
    if (typeof nativeParse !== 'function') return;

    window.DOMParser.prototype.parseFromString = function () {
      var doc = nativeParse.apply(this, arguments);
      try { rewriteCheckoutButtons(doc); } catch (err) {}
      return doc;
    };
    window.DOMParser.__otCheckoutPatchedV11 = true;
    log('DOMParser section normaliser installed');
  }

  function normalizeAnchors(root) {
    root = root || document;
    root.querySelectorAll('a#checkout, a.cart__checkout-button[href*="checkout"]').forEach(function (anchor) {
      if (!isCheckoutContext(anchor)) return;
      anchor.setAttribute(ANCHOR_MARKER, '1');
      anchor.setAttribute('data-ot-native-checkout-link', '1');

      if (anchor.getAttribute('href')) {
        anchor.removeAttribute('aria-disabled');
        anchor.removeAttribute('tabindex');
      }

      // 2-zone Impulse-style button (rendered by cart-summary.liquid):
      // leave its markup intact, only keep the red price cap in sync.
      var totalCap = anchor.querySelector('.ot-co-total');
      if (totalCap || anchor.classList.contains('ot-co-btn')) {
        var total = getCartTotalText(document);
        if (totalCap && total && totalCap.textContent.trim() !== total) {
          totalCap.textContent = total;
        }
        return;
      }

      var span = anchor.querySelector('.button-text');
      if (!span) {
        span = document.createElement('span');
        span.className = 'button-text';
        while (anchor.firstChild) span.appendChild(anchor.firstChild);
        anchor.appendChild(span);
      }
      var label = getButtonLabel(document);
      if (label && (span.textContent || '').trim() !== label) span.textContent = label;
    });
  }

  /* Idle nudge: a calm "don't forget to check out" beat on the 2-zone
     button while the cart drawer is open and untouched. Stops on any
     interaction. Bound once to the persistent cart-drawer-component. */
  function setupNudge() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.__otNudgeWired) return;
    drawer.__otNudgeWired = true;

    var FIRST = 3500, IDLE = 4000, COOL = 7000;
    var timer = null, hovering = false;

    function coBtn() { return drawer.querySelector('a#checkout.ot-co-btn'); }
    function isOpen() { return !!drawer.querySelector('dialog[open]'); }
    function clearT() { if (timer) { clearTimeout(timer); timer = null; } }
    function rest() { var b = coBtn(); if (b) b.classList.remove('ot-nudge'); }
    function nudge() {
      var b = coBtn();
      if (!isOpen() || hovering || !b || b.getAttribute('aria-disabled') === 'true') return;
      b.classList.remove('ot-nudge');
      void b.offsetWidth;
      b.classList.add('ot-nudge');
    }
    function schedule(d) { clearT(); timer = setTimeout(nudge, d); }

    drawer.addEventListener('animationend', function (e) {
      if (e.animationName === 'otCoNudge') { rest(); schedule(COOL); }
    });
    ['pointermove', 'pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      drawer.addEventListener(ev, function () { if (isOpen()) { rest(); schedule(IDLE); } }, { passive: true });
    });
    drawer.addEventListener('pointerenter', function (e) {
      if (e.target && e.target.closest && e.target.closest('a#checkout.ot-co-btn')) { hovering = true; rest(); clearT(); }
    }, true);
    drawer.addEventListener('pointerleave', function (e) {
      if (e.target && e.target.closest && e.target.closest('a#checkout.ot-co-btn')) { hovering = false; schedule(IDLE); }
    }, true);

    document.addEventListener('dialog:open', function () { if (isOpen()) schedule(FIRST); });
    document.addEventListener('dialog:close', function () { clearT(); rest(); });
    new MutationObserver(function () {
      if (isOpen()) schedule(FIRST); else { clearT(); rest(); }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'], subtree: true });

    if (isOpen()) schedule(FIRST);
  }

  function refresh() {
    refreshQueued = false;
    rewriteCheckoutButtons(document);
    normalizeAnchors(document);
    bindTargets(document);
    setupNudge();
    installDrawerCloseGuard();
    maybeRepairStaleEmptyDrawer();
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(refresh);
  }

  async function maybeRepairStaleEmptyDrawer() {
    if (repairTimer) clearTimeout(repairTimer);
    repairTimer = setTimeout(repairStaleEmptyDrawer, 80);
  }

  function drawerLooksEmpty(drawer) {
    if (!drawer) return false;
    var hasRow = !!drawer.querySelector('.cart-items__table-row, [data-cart-item], .cart-item');
    if (hasRow) return false;
    return !!drawer.querySelector('empty-cart-component, .cart-drawer__empty, .cart__empty, #empty-cart-template, [data-empty-cart]');
  }

  async function repairStaleEmptyDrawer() {
    if (window.__OT_CHECKOUT_IN_PROGRESS) return;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || !drawerLooksEmpty(drawer)) return;

    var cart;
    try {
      var cartRes = await fetch(cartUrl('/cart.js'), { credentials: 'same-origin', cache: 'no-store' });
      cart = await cartRes.json();
    } catch (err) { return; }

    if (!cart || !cart.item_count) return;
    log('repairing stale empty drawer; server item_count =', cart.item_count);

    var comp = drawer.querySelector('cart-items-component[data-section-id]');
    var sectionId = comp && comp.dataset && comp.dataset.sectionId;
    if (!comp || !sectionId) return;

    try {
      var plainId = sectionId.replace(/^shopify-section-/, '');
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', plainId);
      var html = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.text(); });
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('cart-items-component[data-section-id="' + sectionId + '"]') || doc.querySelector('cart-items-component');
      if (fresh) {
        comp.replaceWith(document.importNode(fresh, true));
        queueRefresh();
      }
    } catch (err) {}
  }

  function handleCheckoutActivation(e) {
    var target = findCheckoutTarget(e.target);
    if (!target) return;

    if (isCheckoutAnchor(target)) {
      checkoutNow(e, target);
      return;
    }

    if (target.tagName === 'BUTTON') {
      checkoutNow(e, target);
    }
  }

  function earlyCheckoutIntent(e) {
    var target = findCheckoutTarget(e.target);
    if (!target) return;
    setCheckoutIntent(e.type);
  }

  function keyHandler(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var target = findCheckoutTarget(e.target);
    if (!target) return;
    checkoutNow(e, target);
  }

  function submitHandler(e) {
    var form = e.target;
    if (!form || form.id !== 'cart-form') return;
    var submitter = e.submitter || document.activeElement;
    if (!submitter || !findCheckoutTarget(submitter)) return;
    checkoutNow(e, submitter);
  }

  function blockCartMorphsDuringCheckout(e) {
    if (!window.__OT_CHECKOUT_IN_PROGRESS) return;
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    else if (typeof e.stopPropagation === 'function') e.stopPropagation();
    log('blocked cart morph during checkout:', e.type);
  }

  function bindTargets(root) {
    root = root || document;
    root.querySelectorAll('a#checkout, button#checkout, button[name="checkout"][form="cart-form"]').forEach(function (el) {
      if (el.getAttribute(BOUND_ATTR) === '1') return;
      el.setAttribute(BOUND_ATTR, '1');
      el.addEventListener('click', handleCheckoutActivation, true);
      el.addEventListener('keydown', keyHandler, true);
    });
  }

  function bindGlobal() {
    document.addEventListener('pointerdown', earlyCheckoutIntent, { capture: true, passive: true });
    document.addEventListener('touchstart', earlyCheckoutIntent, { capture: true, passive: true });
    document.addEventListener('click', handleCheckoutActivation, true);
    document.addEventListener('keydown', keyHandler, true);
    document.addEventListener('submit', submitHandler, true);
    window.addEventListener('submit', submitHandler, true);

    document.addEventListener('cart:update', blockCartMorphsDuringCheckout, true);
    document.addEventListener('cart:added', blockCartMorphsDuringCheckout, true);
    document.addEventListener('quantity-selector:update', blockCartMorphsDuringCheckout, true);
    document.addEventListener('discount:update', blockCartMorphsDuringCheckout, true);
  }

  function setupObserver() {
    var target = document.body || document.documentElement;
    if (!target) return;
    new MutationObserver(queueRefresh).observe(target, { childList: true, subtree: true, characterData: true });
  }

  function setupPageLifecycle() {
    window.addEventListener('pagehide', function () {
      setCheckoutIntent('pagehide');
    });
    window.addEventListener('pageshow', function () {
      clearCheckoutIntent();
      queueRefresh();
      setTimeout(repairStaleEmptyDrawer, 120);
      log('pageshow — cleared checkout intent');
    });
  }

  function boot() {
    injectStyles();
    patchDOMParser();
    refresh();
    bindGlobal();
    setupObserver();
    setupPageLifecycle();

    document.addEventListener('cart:update', queueRefresh);
    document.addEventListener('cart:added', queueRefresh);
    document.addEventListener('dialog:open', function () {
      queueRefresh();
      setTimeout(repairStaleEmptyDrawer, 150);
      setTimeout(repairStaleEmptyDrawer, 500);
    });

    setTimeout(queueRefresh, 100);
    setTimeout(queueRefresh, 500);
    setInterval(queueRefresh, 1400);

    var current = document.querySelector('cart-drawer-component #checkout');
    log('boot complete; #checkout =', current ? current.tagName : 'NONE', current && current.getAttribute('href'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
